import React from "react";
import logo from "../images/jossif.png";

const Header = () => (
  <header className="App-header">
    <img src={logo} className="App-logo" alt="logo" />
    <p>JS Dev | Web3</p>
  </header>
);

export default Header;
